import { Stack } from '@koob/margaret';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import Carousel, { Modal, ModalGateway } from 'react-images';
import { RoleButton as Button } from 'components/RoleButton';
import ImageField from 'components/Fields/ImageField';

const MiniBloc = styled.div`
  display: flex;
  height: 160px;
  width: 100%;
  position: relative;
  border-radius: 10px;
  ${props => css`
    background-image: url('${props.image}');
    background-position: center center;
    background-size: cover;
  `};
`;

function ImageLabel({ label }) {
  return label ? (
    <div className="absolute bottom-2 left-2 px-2 py-1 text-xs text-white rounded-lg bg-black/50 backdrop-blur-sm">
      {label}
    </div>
  ) : null;
}

export const BlocImages = ({ images, showNames = false }) => {
  const { t } = useTranslation('hotel');
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const isMultiple = images?.length > 1;

  const openModalAtIndex = () => {
    setModalIsOpen(true);
  };

  return (
    <>
      <div className="w-full grid md:grid-cols-3 gap-5">
        <div className="relative col-span-2">
          <ImageField
            name="primaryAttachment"
            shape={isMultiple ? 'multiple' : 'full'}
            url={images[0]?.imageUrl ?? '/img/headerData-image-placeholder.png'}
          />

          {!isMultiple && (
            <Button
              variant="secondary"
              onClick={openModalAtIndex}
              style={{
                position: 'relative',
                float: 'right',
                bottom: 50,
                right: '2%',
              }}
            >
              <i className="fa-light fa-images" />
              {t('showAllPictures')}
            </Button>
          )}

          {showNames && <ImageLabel label={images[0]?.displayName} />}
        </div>

        {isMultiple && (
          <Stack direction="column" gutterSize={1.3}>
            <MiniBloc
              image={images[1]?.imageUrl ?? '/img/hotel-image-placeholder.png'}
            >
              {showNames && <ImageLabel label={images[1]?.displayName} />}
            </MiniBloc>

            <MiniBloc
              image={images[2]?.imageUrl ?? '/img/hotel-image-placeholder.png'}
            >
              {showNames && <ImageLabel label={images[2]?.displayName} />}

              <Stack>
                <Button
                  variant="secondary"
                  onClick={openModalAtIndex}
                  style={{ position: 'absolute', bottom: 10, right: '2%' }}
                >
                  <i className="fa-light fa-images" />
                  {t('showAllPictures')}
                </Button>
              </Stack>
            </MiniBloc>
          </Stack>
        )}
      </div>

      <ModalGateway>
        {modalIsOpen && (
          <Modal onClose={() => setModalIsOpen(false)}>
            <Carousel
              views={images.map(img => {
                return {
                  src: img?.imageUrl,
                  caption: img?.displayName,
                };
              })}
            />
          </Modal>
        )}
      </ModalGateway>
    </>
  );
};
